import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const VillageCard = ({ village, index }) => {
  const { t, lang } = useLang();
  const text = t(`villagesText.${village.slug}`);
  const tagline = text?.tagline || village.tagline;

  return (
    <Link
      to={`/borghi/${village.slug}`}
      data-testid={`village-card-${village.slug}`}
      className="group relative block overflow-hidden bg-[#121212]"
      style={{ aspectRatio: "3/4" }}
      lang={lang}
    >
      <img
        src={village.heroImage}
        alt={`${village.name} — Monferrato, ${t("village.galleryAlt")}`}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.07]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-black/10 transition-opacity duration-700" />
      <div className="absolute inset-0 border border-transparent group-hover:border-[#C5A059]/60 transition-colors duration-700 pointer-events-none" />

      <div className="absolute top-5 left-5">
        <span className="font-serif-display italic text-[#C5A059] text-lg">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-6">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A059] font-medium mb-2">{t("common.borgoLabel")}</p>
        <h3 className="font-serif-display text-2xl lg:text-[1.7rem] text-[#F7F5F0] leading-tight">{village.name}</h3>
        <p className="text-xs text-[#F7F5F0]/60 mt-2 leading-relaxed line-clamp-2">{tagline}</p>
        <div className="mt-4 flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-[#F7F5F0]/80 group-hover:text-[#C5A059] transition-colors duration-500">
          <span className="h-px w-8 bg-[#C5A059] transition-all duration-700 group-hover:w-14" />
          {t("common.scopriBorgo")}
          <ArrowRight size={12} className="transition-transform duration-500 group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
};

export default VillageCard;
